export function fixPrice(data: FormData, key: string, power: number) {
  const rawPrice = data.get(key)?.valueOf();
  if (!rawPrice || typeof rawPrice !== 'string') {
    throw new Error(`No ${key} found`);
  }

  const updatedPrice = parseFloat(rawPrice) * power;
  data.set(key, updatedPrice.toString());
}
